import cn from 'classnames'
import Button from 'ext-ui/components/Button/Button'
import React from 'react'
import { useTranslate } from 'src/localization/Trns'

import style from './InlineConfirmationPanel.style'

type InlineConfirmationPanelProps = {
  message: string
  confirmLabel: string
  onCancel: () => void
  onConfirm: () => void
  confirmButtonVariant?: React.ComponentProps<typeof Button>['variant']
  className?: string
}

const InlineConfirmationPanel: React.FC<InlineConfirmationPanelProps> = ({
  message,
  confirmLabel,
  onCancel,
  onConfirm,
  confirmButtonVariant = 'severe-secondary',
  className,
}) => {
  const translate = useTranslate()

  return (
    <div className={cn('InlineConfirmationPanel', className)} css={style}>
      <p>{message}</p>
      <div className="inline-confirmation-actions">
        <Button variant="text" onClick={onCancel}>
          {translate('Cancel')}
        </Button>
        <Button variant={confirmButtonVariant} onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </div>
    </div>
  )
}

export default InlineConfirmationPanel
